import ReactLoading from "react-loading";

import "./index.scss";
import { useTranslation } from "react-i18next";

const TableLoading = () => {
  const { t } = useTranslation();

  return (
    <tbody id="table-loading-container">
      <tr>
        <td colSpan={100}>
          <div>
            <ReactLoading
              type={"bubbles"}
              color={"#21f228"}
              width={window.innerHeight / 8}
            />
          </div>{" "}
          <p>{t("loading")}</p>
        </td>
      </tr>
    </tbody>
  );
};

export default TableLoading;
